import {
  BreakStyle,
  defineStylesWithBreaks,
  themeIsDark,
  useGLTranslation,
  useMouseover,
  useTheme,
  useThemedStylesWithBreaks
} from 'notability-services-common-frontend'

import {TranslationKey} from 'notability-services-common-universal'
import {addingBasePath} from '../config'
import {useMemo} from 'react'

const styles = defineStylesWithBreaks((theme, font) => {
  const absoluteContainer: BreakStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center'
  }
  return {
    ssoButton: {
      border: 'none',
      borderRadius: '8px',
      outline: 'none',
      height: '50px',
      gap: '12px',
      alignItems: 'center',
      color: theme.core.f1,
      backgroundColor: theme.core.b2,
      ...font.body,
      placeContent: 'flex-start',
      cursor: 'pointer',
      position: 'relative'
    },

    ssoHover: {
      backgroundColor: theme.core.b3
    },

    icon: absoluteContainer,
    text: {
      ...absoluteContainer,
      justifyContent: 'center'
    }
  }
})

type GenericSsoButtonProps = {
  provider: 'Google' | 'Apple' | 'Microsoft'
  onClick: () => void
}

export function SsoButtonTemplate({onClick, provider}: GenericSsoButtonProps) {
  const s = useThemedStylesWithBreaks(styles)
  const {t} = useGLTranslation()
  const {theme} = useTheme()

  const [translationKey, logoPath] = useMemo((): [TranslationKey, string] => {
    switch (provider) {
      case 'Google': {
        return ['continueWithGoogle', '/googleLogo.svg']
      }
      case 'Apple': {
        return ['continueWithApple', themeIsDark(theme.name) ? '/appleLogoLight.svg' : '/appleLogoDark.svg']
      }
      case 'Microsoft': {
        return ['continueWithMicrosoft', '/microsoftLogo.svg']
      }
    }
  }, [provider, theme.name])

  const [hovered, hoveredHandlers] = useMouseover()

  const buttonStyle = useMemo(() => {
    if (hovered) {
      return {
        ...s.ssoButton,
        ...s.ssoHover
      }
    } else {
      return s.ssoButton
    }
  }, [s, hovered])

  return (
    <button type={'button'} style={buttonStyle} {...hoveredHandlers} onClick={onClick}>
      <div style={s.icon}>
        <img src={addingBasePath(logoPath)} alt={''} />
      </div>
      <div style={s.text}>{t(translationKey)}</div>
    </button>
  )
}
